import { render, staticRenderFns } from "./UnfinishedModules.vue?vue&type=template&id=cf1827c2&"
import script from "./UnfinishedModules.vue?vue&type=script&lang=js&"
export * from "./UnfinishedModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports